<template>
  <div class="trainer-bound bottom-padding">
    <weui-group>
      <weui-cell>
        <div class="header-cell">
          <div class="avatar">
            <img :src="trainer.avatar" >
          </div>
          <div class="info">
            <div class="name">{{ trainer.name }}</div>
            <div class="info-line">
              <div class="nickname">备注：{{ trainer.name_remarks }}</div>
              <weui-button type="default" class="inline-btn" @click="changeRemarksName">修改</weui-button>
            </div>
          </div>
        </div>
      </weui-cell>
    </weui-group>
    <weui-group>
      <weui-cell label="微信昵称">{{ trainer.wechat_nickname }}</weui-cell>
      <weui-cell label="性别">{{ formatGender(trainer.gender) }}</weui-cell>
      <!--weui-cell label="会员备注">{{ trainer.comment }}</weui-cell-->
    </weui-group>
    <weui-group>
      <weui-textarea placeholder="补充描述" v-model="trainer.comment" :rows="4" :max-length="200" />
    </weui-group>
    <weui-button-area>
      <weui-button type="default" @click="saveComment">设置描述</weui-button>
    </weui-button-area>
    <weui-group>
      <weui-cell :link="true" label="剩余课程" :tips="`${ Math.max(trainer.course_count - trainer.closed_course_count, 0) } 节`" @click="changeCourseCount" />
      <weui-cell label="总完成课程" :tips="`${ trainer.closed_course_count } 节`" />
      <weui-cell v-for="stat in trainer_course_monthly_stats" :key="stat.month" v-if="stat.closed_course_count" :label="`${getMonth(stat.month)}月完成课程`" :tips="`${stat.closed_course_count} 节`" />
    </weui-group>
    <weui-button-area>
      <weui-button type="primary" @click="newCourse">立刻为其排课</weui-button>
      <weui-button type="default" @click="goback">返回列表</weui-button>
      <weui-button type="default" @click="unbind">解除绑定</weui-button>
      <weui-button type="warn" @click="deleteIt">删除会员</weui-button>
    </weui-button-area>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import weui from '@/wechat/weui';
import { WeuiGroup, WeuiCell, WeuiTextarea, WeuiButtonArea, WeuiButton } from '@/components/weui';
import mixinFormatters from '@/mixins/formatters';
import mixinDatetime from '@/mixins/datetime';

import { ROUTE_TRAINER_VIEW, ROUTE_TRAINER_NICKNAME, ROUTE_TRAINER_LIST, ROUTE_COURSE_BOOT_TRAINER } from '@/router/names';
import { FETCH_TRAINER_COURSE_MONTHLY_STATS, PATCH_TRAINER, WECHAT_UNBIND_TRAINER, DELETE_TRAINER } from '@/store/trainer/types';

const { mapState, mapActions } = createNamespacedHelpers('trainer');

export default {
    props: {
        trainer: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            id: 0,
        };
    },
    computed: {
        ...mapState({
            trainer_course_monthly_stats: state => state.trainer_course_monthly_stats || [],
            patched: state => state.patched || {},
        }),
    },
    created() {
        const { id } = this.$route.params;
        this.id = id;
        this.fetchTrainerCourseMonthlyStats({ id });
    },
    methods: {
        ...mapActions({
            fetchTrainerCourseMonthlyStats: FETCH_TRAINER_COURSE_MONTHLY_STATS,
            patchTrainer: PATCH_TRAINER,
            wechatUnbind: WECHAT_UNBIND_TRAINER,
            deleteTrainer: DELETE_TRAINER,
        }),
        changeRemarksName() {
            const { id } = this.trainer;
            this.$router.push({
                name: ROUTE_TRAINER_NICKNAME,
                params: {
                    id,
                },
            });
        },
        saveComment() {
            const { id } = this.trainer;
            this.patchTrainer({
                trainer: {
                    id,
                    comment: this.trainer.comment,
                },
            });
        },
        async changeCourseCount() {
            const options = [];
            for (let i = 1; i < 90; i += 1) {
                options.push({
                    label: i,
                    value: i,
                });
            }
            const result = await weui.picker(options, {
                defaultValue: [Math.max(this.trainer.course_count - this.trainer.closed_course_count, 0)],
            });
            if (!result) {
                return;
            }
            const value = result[0].valueOf();

            await this.patchTrainer({
                trainer: {
                    id: this.id,
                    course_count: this.trainer.closed_course_count + value,
                },
            });

            weui.toast('已设置剩余课程');
            this.trainer.course_count = this.patched.course_count;
        },
        newCourse() {
            this.$router.push({
                name: ROUTE_COURSE_BOOT_TRAINER,
                params: {
                    id: this.trainer.id,
                },
            });
        },
        goback() {
            this.$router.replace({
                name: ROUTE_TRAINER_LIST,
            });
        },
        async unbind() {
            const { id } = this.trainer;
            const confirmed = await weui.confirm('确认解除会员的微信绑定吗？');
            if (!confirmed) {
                return;
            }
            await this.wechatUnbind({ id });
            this.$router.replace({
                name: ROUTE_TRAINER_VIEW,
                params: { id },
            });
        },
        async deleteIt() {
            const confirmed = await weui.confirm('确认删除当前会员吗？');
            if (!confirmed) {
                return;
            }

            await this.deleteTrainer({ id: this.trainer.id });
            this.goback();
        },
    },
    mixins: [
        mixinFormatters,
        mixinDatetime,
    ],
    components: {
        WeuiGroup,
        WeuiCell,
        WeuiTextarea,
        WeuiButtonArea,
        WeuiButton,
    },
};
</script>

<style lang="scss" scoped>
.header-cell {
    display: flex;

    .avatar {
        width: 17.066666667vw;
        height: 17.066666667vw;

        > img {
            width: 100%;
            border-radius: 1.2vw;
            border: solid 1px #b4b4b4;
        }
    }

  .info {
      margin-left: 3.2vw;

      .title {
          color: black;
          font-size: 4.8vw;
          line-height: 9.333333333vw;
      }

      .info-line {
          margin-top: 1.2vw;
          display: flex;
          align-items: center;
      }

      .nickname {
          font-size: 4.8vw;
          line-height: 1.4;
          color: #9b9b9b;
      }

      .inline-btn {
          margin-left: 2vw;
          font-size: 4vw;
          line-height: 1.68;
          padding: 0 2vw;
      }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/trainer/BoundView.vue